<h2 class="noPublished" *ngIf="noPublishAgenda">La agenda del evento no ha sido publicada</h2>
<div *ngIf="isAdmin && !agenda" class= "addButton">
  <button mat-fab color="warn" (click)="addAgendaOpen(openSpaceId)" style="outline: none;" title="Crear agenda">
    <mat-icon>add</mat-icon>
  </button>
</div>
<div *ngIf="agenda">
<h2>Agenda
  <button *ngIf="isAdmin" mat-icon-button style="outline: none;" [matMenuTriggerFor]="menuagenda">
    <mat-icon>more_vert</mat-icon>
  </button>
  <mat-menu #menuagenda="matMenu">
    <button mat-menu-item style="outline: none;" (click)="addSessionOpen(agenda.id)">
      <mat-icon>more_time</mat-icon>
      <span>Agregar sesión</span>
    </button>
    <button mat-menu-item style="outline: none;" (click)="editAgenda(agenda)">
      <mat-icon>edit</mat-icon>
      <span>Editar agenda</span>
    </button>
    <button mat-menu-item style="outline: none;" (click)="genAgenda(agenda.id)">
      <mat-icon>flash_on</mat-icon>
      <span>Auto-generar</span>
    </button>
    <button *ngIf="!agenda.publicAgenda" mat-menu-item style="outline: none;" (click)="publishAgenda(agenda)">
      <mat-icon>publish</mat-icon>
      <span>Publicar</span>
    </button>
    <button *ngIf="agenda.publicAgenda" mat-menu-item style="outline: none;" (click)="unPublishAgenda(agenda)">
      <mat-icon>unpublished</mat-icon>
      <span>Borrador</span>
    </button>
  </mat-menu>
</h2>
<mat-card style="margin-top: 1rem;">
  <mat-card-subtitle><strong>Lugar: </strong>{{agenda.place}}  | <strong>Hora: </strong>{{agenda.startTime}}
    | <strong>Estado: </strong>{{agenda.publicAgenda ? 'Publicada' : 'No publicada'}}</mat-card-subtitle>
  <mat-card-content>{{agenda.description}}</mat-card-content>
</mat-card>

<div style="display: flex;" cdkDropListGroup>
  <mat-card *ngIf="isAdmin" style="margin-top: 1rem;">
    <div *ngIf="isAdmin" style="padding-bottom: 8px; font-weight: bold;">Propuestas sin asignar
      <button mat-icon-button [matMenuTriggerFor]="sort" style="outline: none;">
        <mat-icon>sort</mat-icon>
      </button>
      <mat-menu #sort="matMenu">
          <button mat-menu-item (click)="sortUnassignedProposalsBy('maxVotes')" style="outline: none;" >
            <mat-icon>filter_1</mat-icon>
              <span [ngStyle]="{'font-weight': filterByVotes ? 'bold' : 'normal'}">Ordenar por Votos</span>
          </button>
          <mat-divider></mat-divider>
          <button mat-menu-item (click)="sortUnassignedProposalsBy('intentionVotes')" style="outline: none;">
              <mat-icon>filter_2</mat-icon>
              <span [ngStyle]="{'font-weight': filterByIntention ? 'bold' : 'normal'}">Ordenar por Intención</span>
          </button>
      </mat-menu>
  </div>
    <mat-divider></mat-divider>
    <div *ngIf="isAdmin" cdkDropList cdkDropListOrientation="vertical"  [cdkDropListData]="unassignedProposals" id="unassignedProposals" class="track-container-list-unnasigned" (cdkDropListDropped)="drop($event)">
      <div class="proposal-box_{{this.getColor(proposal.proposalId)}}" *ngFor="let proposal of unassignedProposals" cdkDrag>
        <div>
          <p class="proposalTitle"><strong>Título:</strong> {{proposal.title}}</p> <br/>
          <strong>Intención de votos:</strong> {{proposal.votesIntention}}<br/>
          <strong>Votos totales:</strong> {{proposal.votesTotal}}
        </div>
      </div>
    </div>
  </mat-card>
  <mat-card style="margin-top: 1rem;width: -webkit-fill-available;">
    <div style="padding-bottom: 8px; font-weight: bold;">Sesiones</div>
    <mat-nav-list style="padding-top: 0px;">
        <div *ngFor="let session of agenda?.sessions">
          <mat-divider></mat-divider>
          <div mat-subheader>
            <mat-icon>access_time</mat-icon><div><strong>&nbsp;Sesión -&nbsp;</strong>Comienzo: {{session.startTime}}&nbsp;</div>
            <div> | Duración:{{session.minutesDuration}}&nbsp;minutos</div>
            <button *ngIf="isAdmin" mat-icon-button style="outline: none;" [matMenuTriggerFor]="menusession">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menusession="matMenu" >
              <button mat-menu-item style="outline: none;" (click)="addTrackOpen(session.id)" >
                <mat-icon>add_road</mat-icon>
                <span>Agregar track</span>
              </button>
              <button mat-menu-item style="outline: none;" (click)="editSession(session)" >
                <mat-icon>edit</mat-icon>
                <span>Editar sesión</span>
              </button>
            </mat-menu>
          </div>
          <section *ngIf="session.displayable" id="comingSoonSession">
            <div class="coming-soon">
              Sesión próxima a iniciar en: <span>  </span>
              <span><countdown [config]="{ leftTime: session.secondsRemaining, format: 'm:s' }"></countdown></span>
             <span></span> minutos
            </div>
          </section>
          <mat-divider></mat-divider>
          <mat-list-item *ngFor="let track of session.tracks" style="display: inline-block;height: auto;width: auto;">
            {{agenda?.sessions?.tracks}}
            <div mat-line class="track-container">

              <div mat-subheader>

                <div class="track-title"
                     title={{track.channel}}><strong >Track:&nbsp;</strong>{{ (track.channel.length>40)? (track.channel | slice:0:38)+'...':(track.channel) }} &nbsp;</div>
                <div *ngIf="track.documentation" >
                  <a href="{{track.documentation}}" target="_blank" style="outline: none;">
                    <mat-icon matTooltip="Documentación">info</mat-icon>
                  </a>
                </div>
                <div *ngIf="track.talkLink" >
                  <a href="{{track.talkLink}}" target="_blank" style="outline: none;">
                    <mat-icon matTooltip="Link a charla">link</mat-icon>
                  </a>
                </div>
                <div>
                  <button *ngIf="isAdmin" mat-icon-button style="outline: none;" [matMenuTriggerFor]="menusession">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                </div>
                <mat-menu #menusession="matMenu" >
                  <button mat-menu-item style="outline: none;" (click)="editTrack(track,session.id)" >
                    <mat-icon>edit</mat-icon>
                    <span>Editar track</span>
                  </button>
                  <button mat-menu-item style="outline: none;" (click)="showNotesTrack(track)" >
                    <mat-icon>notes icon</mat-icon>
                    <span>Ver notas</span>
                  </button>
                  <button mat-menu-item style="outline: none;" (click)="editUrlDocTrack(track,session.id)" >
                    <mat-icon>menu_book</mat-icon>
                    <span>Documentación</span>
                  </button>
                  <button mat-menu-item style="outline: none;" (click)="editUrlTalk(track,session.id)" >
                    <mat-icon>link</mat-icon>
                    <span>Link a charla</span>
                  </button>
                </mat-menu>
              </div>

            </div>
            <div mat-line>
              <div cdkDropList cdkDropListOrientation="vertical" [cdkDropListData]="track.proposals" class="track-container-list" (cdkDropListDropped)="drop($event)">
                <div  *ngFor="let proposal of track.proposals"  class="proposal-box_{{this.getColor(proposal.proposalId)}}" cdkDrag [cdkDragDisabled]="!isAdmin">
                  <div >
                    <p class="proposalTitle"><strong>Título:</strong> {{proposal.title}}</p><br/>
                    <div *ngIf="isAdmin"><strong>Intención de votos:</strong> {{proposal.votesIntention}}<br/></div>
                    <div *ngIf="isAdmin || agenda?.showVotes"><strong>Votos totales:</strong> {{proposal.votesTotal}}</div>
                  </div>
                </div>
              </div>
            </div>
          </mat-list-item>
          <p matLine></p>
        </div>
    </mat-nav-list>
  </mat-card>

</div>
</div>
